module.exports = require("./fr-MQ.js");